import React from 'react'
import { LoginPage } from '@pilot-hub/ui'
import { userApi } from '@pilot-hub/api-client'
import { useAuth } from '@pilot-hub/auth'
import { useNavigate } from 'react-router-dom'

interface LoginUser {
  id: string
  benutzername: string
  vorname?: string
  nachname?: string
}

export function LoginPageAdmin() {
  const { login } = useAuth()
  const navigate = useNavigate()
  
  return (
    <LoginPage
      module="admin"
      title="Admin-Modul"
      loginEndpoint="/auth/login"
      redirectPath="/dashboard"
      getLoginUsers={async (): Promise<LoginUser[]> => {
        const response = await userApi.getLoginAdmins()
        return response.data as LoginUser[]
      }}
      onLogin={login}
    />
  )
}